const triggerOpenDrawer = (controller) => {
  const drawer = document.querySelector("[data-controller='drawer']");
  if (drawer) {
    document.dispatchEvent(
      new CustomEvent("drawer:open")
    )
    document.getElementById("active-drawer").setAttribute('data-controller', controller)
  }
}

// TODO: replace mm.drawer events with non backbone events
export const triggerLogin = () => {
  // Refactor to work with new login flow. Login is not in the drawer. Find all instances of onClick={triggerLogin}
  // mm.drawerLoginPage.notify(
  //   "You must be logged in to perform this action. Sign in or register below."
  // )
  // mm.drawer.trigger("login")
}

export const triggerNewsletterSignup = () => {
  
  // mm.drawerProxy.trigger("subscribe")
}
